import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import { loadStripe } from "@stripe/stripe-js";
import {
  Card,
  CardContent,
  MenuItem,
  InputLabel,
  Select,
  Alert,
  Grid,
  Typography
} from "@mui/material"
import Tooltip from '@mui/material/Tooltip';
import PaymentIcon from '@mui/icons-material/Payment';
import { currencies } from './Currency';
 
let stripePromise;
const getStripe = () => {
  if (!stripePromise) {        
    stripePromise = loadStripe(`${process.env.REACT_APP_PUBLISHABLEKEY}`);   
  }  
  
  return stripePromise;
};

const stripe1 = getStripe();

export default function ResponsiveDialog() {
  const [open, setOpen] = React.useState(false);
  const [stripeError, setStripeError] = React.useState(null);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    window.location.reload();
  };

  const [amountopen, setAmountopen] = React.useState(false);
  const handleAmountclose = () => {
    setAmountopen(false);
    window.location.reload();
  };

  const [state, setState] = React.useState({
    currency: "",
    credit: "",
    amount: ""
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleCurrencyConversion = () => {
    const postdata = {
      currency: state.currency,
      credit : state.credit
    }
    fetch(`${process.env.REACT_APP_API_URL}/api/currencyconversion/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: JSON.stringify(postdata)
    })
      .then((resp) => resp.json())
      .then((data) => {
        let name = 'amount'
        setState((prevState) => ({
          ...prevState,
          [name]: data,
        }));
        setOpen(false);
        setAmountopen(true);
      })
      .catch((error) => {
        console.error(error);
        window.location.reload();
      }); 
  };  

  const redirectToCheckout = async () => {
    const apikey = 'pk_test_51LHo3mSFrVqruqBvSxzYy7DxqEEOqGkRDx65DniRDqpzS82xsY6iMbabTSkj2JEGOrjg32qPqZ25AlmZAEcmb5rk00m7AO9yeC';
    const stripe = await loadStripe(apikey);    
    const postdata = {
      currency: state.currency,
      amount : state.amount,
      credit : state.credit
    }
    fetch(`${process.env.REACT_APP_API_URL}/api/sessioncheckout/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
      body: JSON.stringify(postdata)
    })
      .then((resp) => resp.json())
      .then((data) => {
          if (data.id) {
            const { error } = stripe.redirectToCheckout({sessionId: data.id});
            if (error) { 
              setStripeError(error.message) 
            }
          } else {
            setStripeError(data)
          }
      })
      .catch((error) => {
        console.error(error);
        window.location.reload();
      }); 
  };  
  return (
    <div>
      <Tooltip title="Pay" arrow>
        <Button
          style={{textAlignLast: 'right', webkitWritingMode: 'horizontal-tb'}}
          variant="contained"
          color="primary"
          size="small"
          onClick={handleClickOpen}
          startIcon={<PaymentIcon />}
          sx={{ borderRadius: '50px', px: 2.5, py: 0.75 }}
          aria-label="Pay"
        >
          Pay
        </Button>
      </Tooltip>

      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="sm"
        aria-labelledby="customized-dialog-title"
      >
        <DialogTitle onClose={handleClose} id="customized-dialog-title">Pay Your Wallet <strong>(Current balance: $100)</strong></DialogTitle>
        {stripeError ?
        <Alert severity="error">{stripeError}</Alert>
        : "" }
        
        <DialogContent>
        <InputLabel id="expmonth">Currency</InputLabel>
        <Select
                            id={`currency`}
                            fullWidth
                            onChange={handleChange}
                            value={state.currency}
                            name={`currency`}
                            autoComplete={`currency`}
                            >
                            <MenuItem>-- --</MenuItem>
                            {Object.keys(currencies).map(item => {
          return(
              <MenuItem value={currencies[item].code}>{currencies[item].code}</MenuItem>
          )
      })}                            
                          </Select>
         <br />
         <br />
         <br />
        <InputLabel id="expmonth">Credits</InputLabel>
        <TextField
          fullWidth
          name="credit"
          id="credit"
          label="Credit"
          value={state.credit}
          onChange={(e) => {
            const value = e.target.value;
            if (/^\d*$/.test(value)) {
              handleChange(e);
            }
          }}
          inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
          required
          autoComplete="off"
        />


        </DialogContent>
        <DialogActions>
          <Tooltip title="Cancel" arrow>
            <Button autoFocus onClick={handleClose} variant="contained" color="primary" sx={{ borderRadius: '50px', px: 2.5, py: 0.75 }} aria-label="Cancel">
              Cancel
            </Button>
          </Tooltip>
          <Tooltip title="Next" arrow>
            <span>
              <Button 
                disabled={state.currency && state.credit ? false : true} 
                variant="contained" 
                autoFocus 
                onClick={handleCurrencyConversion} 
                color="primary"
                sx={{ borderRadius: '50px', px: 2.5, py: 0.75 }}
                aria-label="Next"
              >
                Next
              </Button>
            </span>
          </Tooltip>
        </DialogActions>
      </Dialog>

      <Dialog
        fullScreen={fullScreen}
        open={amountopen}
        onClose={handleAmountclose}
        fullWidth
        maxWidth="sm"
        aria-labelledby="customized-dialog-title"
      >
        {stripeError ?
        <Alert severity="error">{stripeError}</Alert>
        : "" }
        
        <DialogContent>
  <Card
    sx={{ height: '100%' }}
  >
    <CardContent>        
      <Grid
        container
        spacing={0}
      >
        <Grid item>
        <Grid container>
        <Typography variant="h5" display="block" gutterBottom>
                Currency:  
                <strong className="ml-4">{`${state.currency}`}</strong>
                </Typography>             
            </Grid>          
        <Grid container>
        <Typography variant="h5" display="block" gutterBottom>
                Credits:  
                <strong className="ml-4">{`${state.credit}`}</strong>
                </Typography>             
            </Grid>
            <Grid container>
        <Typography variant="h5" display="block" gutterBottom>
                Amount:  
                {currencies && currencies[state.currency] ? <strong className="ml-4">{`${currencies[state.currency].symbol_native}`}</strong> : ""}
                <strong >{`${state.amount} /-`}</strong>
                </Typography>             
            </Grid>
        </Grid>
      </Grid>  
      <Typography variant="h5"><small>
              Note: Handling charge or Tax included in the total cost
              </small></Typography>  
      </CardContent>
  </Card>            
        </DialogContent>
        <DialogActions>
          <Tooltip title="Cancel" arrow>
            <Button autoFocus onClick={handleAmountclose} color="primary" sx={{ borderRadius: '50px', px: 2.5, py: 0.75 }} aria-label="Cancel">
              Cancel
            </Button>
          </Tooltip>
          <Tooltip title="Checkout" arrow>
            <span>
              <Button 
                disabled={state.amount ? false : true} 
                variant="contained" 
                autoFocus 
                onClick={redirectToCheckout} 
                color="primary"
                sx={{ borderRadius: '50px', px: 2.5, py: 0.75 }}
                aria-label="Checkout"
              >
                Checkout
              </Button>
            </span>
          </Tooltip>
        </DialogActions>
      </Dialog>      
    </div>
  );
}